<template>
    <footer :class="additionalClass" class="footer">
        <div class="footer__container">
            <div class="footer__copyright">
                © фитмост | Москва • Россия • <a href="mailto:info@fitmost.ru">info@fitmost.ru</a> {{ localeYear }}
            </div>
            <div class="footer__socials">
                <a class="footer__socials-link" href="https://t.me/fitmost" target="_blank" rel="noreferrer noopener">
                    <img :src="telegramUrl" alt="Telegram">
                </a>
                <a class="footer__socials-link" href="https://vk.com/fitmost" target="_blank" rel="noreferrer noopener">
                    <img :src="vkUrl" alt="VK">
                </a>
            </div>
        </div>
    </footer>
</template>

<script setup>
import { computed } from "vue";

defineProps({
    additionalClass: {
        type: String,
        default: ''
    },
})

const telegramUrl = new URL('@icons/telegram.svg', import.meta.url);
const vkUrl = new URL('@icons/vk.svg', import.meta.url);
const localeYear = computed(() => {
    return new Date().getFullYear();
});

</script>
